






















import { Component } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import Card from "../utility/Card.vue";
import PartnerReportCardGeneral from "./PartnerReportCardGeneral.vue";

@Component({
  components: {
    Card,
    LatestEntriesCardEmpty
  }
})
export default class PartnerReportCardBody extends PartnerReportCardGeneral {}
